import { useTranslations } from "use-intl";

export function NotSpecified() {
  const t = useTranslations("Common");

  return <span>{t("Not specified")}</span>;
}
